<app-composition-production
  *ngIf="composition && username"
  [username]="username"
  [composition]="composition"
/>
